import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { images } from "../../assets/Images/assetsImages";
import { login } from '../../API/adminAPI';

export default function AdminLogin() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (err) => {
    err.preventDefault();
    try {
        const response = await login(formData);
    
        if (response.success) {
          sessionStorage.setItem('authToken', response.token);
          // Navigate to the AdminDashboard route
          navigate('/admin/dashboard');

        } else {
          alert(response.message);
        }
      } catch (error) {
        alert('An error occurred. Please try again..');
      }
  };

  return (
    <section className="w-full h-[100vh] flex justify-center items-center">
      <div className="w-[80%] xs:h-[90%] h-[35rem] sm:h-[50rem] lg:h-[80%] bg-[#dedede] flex flex-col lg:flex-row px-[4%] py-[4%] rounded-[20px] shadow-md">
        <div className="h-[50%] xs:h-[35%] lg:h-[100%] lg:w-[50%] md:mb-8">
          <img
            src={images.Logo}
            className="w-full h-full object-contain lg:w-[80%]"
            alt="logo"
          />
        </div>

        <div className="h-[50%] xs:h-[60%] lg:h-[100%] w-full lg:w-[50%] flex justify-center items-center sm:items-center">
          <div className=" w-full flex flex-col justify-center items-center">
            <div className="w-full mb-[20px] 2xl:mb-[30px]">
              <label className="text-black text-[20px] sm:text-[23px]">
                username
              </label>

              <input
                className="w-full mt-[1rem] xs:mt-[0.5rem] h-[2rem] 2xl:h-[3rem] sm:h-[2.5rem] rounded pl-[2rem]"
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </div>

            <div className="w-full mb-[2rem] 2xl:mb-[4rem]">
              <label className="text-black text-[20px] sm:text-[23px]">
                password
              </label>

              <input
                className="w-full mt-[1rem] h-[2rem] 2xl:h-[3rem] rounded sm:h-[2.5rem] pl-[2rem]"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            <button
              onClick={handleSubmit}
              className="bg-[#6A480A] hover:bg-[#714E16] text-white font-bold h-[2rem] sm:h-[3rem] rounded-[15px] text-[20px] sm:text-[23px] w-full">
              Login
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
